import { BLOCK_CLASSES as e } from "../../constants.js";
const o = {
  content: "",
  group: "block",
  attrs: {
    type: { default: "spacer" },
    height: { default: 20 }
  },
  toDOM(t) {
    return [
      "div",
      {
        class: `${e.blockContainer} ${e.spacer} intercom-spacer-container`
      }
    ];
  }
};
export {
  o as spacerSpec
};
